import type { MessengerApiAttachmentMetadata } from '@widgets/messenger/types/api/common'

export type Boundaries = {
  width: number
  height: number
}

export type Appear = 'static' | 'fixed'

export type NestedKeyOf<ObjectType extends object> = {
  [Key in keyof ObjectType & (string | number)]: ObjectType[Key] extends object
    ? `${Key}` | `${Key}.${NestedKeyOf<ObjectType[Key]>}`
    : `${Key}`
}[keyof ObjectType & (string | number)]

export type WidgetButtonColor =
  | 'blue'
  | 'orange'
  | 'green'
  | 'red'
  | 'cyan'
  | 'violet'
  | 'purpur'
  | 'brown'
  | 'danger'
  | 'success'
  | 'secondary'

export type WidgetButtonCustomColor = {
  primary: string // HEX
  secondary: string // HEX
}

export const isWidgetButtonCustomColor = (
  color: WidgetButtonColor | WidgetButtonCustomColor,
): color is WidgetButtonCustomColor => {
  return typeof color === 'object'
}

export type WidgetButtonView = 'solid' | 'outline' | 'transparent' | 'hover-transparent'

export type WidgetButtonSize = '40' | '36' | '32' | '28' | '20'

export interface EventEmitter {
  on<T>(eventCode: string, callback: (payload: T) => void): string
  remove(id: string): void
  emit<T>(eventCode: string, payload: T): void
}

export type ChatScrollPosition = {
  scrollTop: number
  atBottom: boolean
}

// All fields should be gotten from BE
export type WidgetUploadedAttachment = {
  type: 'uploadedAttachment'
  id: string
  name: string // file.pdf
  size: number // bytes
  mimeType: string // application/pdf
  downloadUrl: string
  previewUrl?: string // if it's an image
  metadata?: MessengerApiAttachmentMetadata
}

export type WidgetUploadingAttachmentError = {
  text: string
  canRetry: boolean
}

export type WidgetUploadingAttachment = {
  type: 'uploadingAttachment'
  id: string // temp id from FE
  name: string // file.pdf
  size: number // bytes
  mimeType: string // application/pdf
  uploadProgress: number // part of size in bytes
  previewUrl?: string // if it's an image, from file blob
  error?: WidgetUploadingAttachmentError
}

export type WidgetAttachment = WidgetUploadedAttachment | WidgetUploadingAttachment

export const isWidgetUploadingAttachment = (attachment: WidgetAttachment): attachment is WidgetUploadingAttachment =>
  attachment.type === 'uploadingAttachment'

export const isWidgetUploadedAttachment = (attachment: WidgetAttachment): attachment is WidgetUploadedAttachment =>
  attachment.type === 'uploadedAttachment'
